import brpLogo from 'brands/buffalo/assets/img/lenders/brp.svg'
import forestRiverLogo from 'brands/forest-river/assets/img/lenders/forest-river.svg'
import ApplicationPortal from 'state/enums/ApplicationPortal'

export type OemPortalBrandKey = 'brp' | 'forestRiver'

export interface OemPortalBrandConfig {
    targetPortal: ApplicationPortal
    logo: string
    logoAlt: string
    // Label woven into the loading interstitial copy ("Finding your <label>
    // offers...") shown while the application copy is created.
    interstitialLabel: string
    colors: {
        banner: string
        bannerText: string
        buttonBackground: string
        buttonBackgroundHover: string
        buttonText: string
    }
    approval: {
        description: string
        ctaLabel: string
    }
    wtd: {
        title?: string
        description: string
        ctaLabel: string
    }
}

export const oemPortalBrands: Record<OemPortalBrandKey, OemPortalBrandConfig> =
    {
        brp: {
            targetPortal: ApplicationPortal.BUFFALO,
            logo: brpLogo,
            logoAlt: 'BRP Financial Services',
            interstitialLabel: 'BRP Financial Services',
            colors: {
                banner: '#000000',
                bannerText: '#ffffff',
                buttonBackground: '#ffd200',
                buttonBackgroundHover: '#e6bd00',
                buttonText: '#000000',
            },
            approval: {
                description:
                    'Check for applicable BRP Finance Offers and Promos',
                ctaLabel: 'View BRP Offers & Promos',
            },
            wtd: {
                title: '✦ This is a New BRP unit',
                description:
                    'Move your application over to the BRP Financial Services portal to check for eligible offers and promotions.',
                ctaLabel: 'View BRP Financial Services Offers & Promos',
            },
        },
        forestRiver: {
            targetPortal: ApplicationPortal.FOREST_RIVER,
            logo: forestRiverLogo,
            logoAlt: 'Forest River Finance',
            interstitialLabel: 'Forest River',
            colors: {
                banner: '#026957',
                bannerText: '#ffffff',
                buttonBackground: '#ffffff',
                buttonBackgroundHover: '#f2f2f2',
                buttonText: '#026957',
            },
            approval: {
                description:
                    'This is a new Forest River vehicle. Your deal may qualify for Dealer Reserve.',
                ctaLabel: 'View Forest River Offers',
            },
            wtd: {
                description:
                    'Your deal may qualify for Dealer Reserve and Promo Rates. Move your application over to the Forest River portal to check for eligible offers and promotions.',
                ctaLabel: 'View Forest River Offers',
            },
        },
    }
